import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AnimatedEllipsisModule } from '../animatedEllipsis/AnimatedEllipsisModule';
import { AngularUpgradeHelper } from '../helpers/AngularUpgradeHelper';
import { LoadingAnimationComponent } from './LoadingAnimationComponent';
import { FlexModule } from '@angular/flex-layout';

@NgModule({
    imports: [
        AnimatedEllipsisModule,
        CommonModule,
        MatProgressSpinnerModule,
        FlexModule
    ],
    // tslint:disable-next-line: object-literal-sort-keys
    declarations: [
        LoadingAnimationComponent
    ],
    entryComponents: [
        LoadingAnimationComponent
    ],
    exports: [
        LoadingAnimationComponent
    ]
})
export class LoadingAnimationModule {
    private commonModuleName = 'app.areas.common';

    constructor() {
        AngularUpgradeHelper.downgradeComponents(this.commonModuleName, [
            LoadingAnimationComponent
        ]);
    }
}
